import type FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import updateFileProviderItemsSelection from './updateFileProviderItemsSelection';
import { action } from 'satcheljs/lib/legacy';
import { lazyIsInSearchMode } from 'owa-search';
import { lazyEndSearchSession } from 'owa-search-actions';
import { SearchScenarioId } from 'owa-search-store';

export default action('closeFilePicker')(function closeFilePicker(
    maxAllowedLocalFileSize: number,
    viewState: FilePickerPanelViewState
) {
    viewState.isOpen = false;

    // Clear the selection when the file picker is closed
    updateFileProviderItemsSelection(
        [],
        maxAllowedLocalFileSize,
        viewState.selectedFileProvider,
        viewState
    );

    return lazyIsInSearchMode.import().then(isInSearchMode => {
        if (isInSearchMode(SearchScenarioId.FilesPicker)) {
            return lazyEndSearchSession.import().then(endSearchSession => {
                endSearchSession(SearchScenarioId.FilesPicker);
            });
        }

        return Promise.resolve();
    });
});
